import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Layout from '../components/Layout';

interface Props {
  lang: 'en' | 'ru' | 'it' | 'fr';
}

const tags = ['PMBOK', 'SCRAM', 'KANBAN', 'REMOTE KANBAN', 'GIT', 'JIRA', 'RedMine', 'YouTrack', 'Kayako', 'Capistrano', 'Jenkins'];

export default function Interest({ lang }: Props) {
  const { t } = useTranslation('interest');
  const tc = useTranslation('common').t;

  return (
    <Layout lang={lang}>
      <div className="blog-post">
        <h2 className="blog-post-title">{t('title')}</h2>
        <p className="blog-post-meta">
          {t('date')} &nbsp;|&nbsp; <Link to={lang === 'en' ? '/' : `/${lang}`}>{tc('mainPage')}</Link>
          &nbsp;|&nbsp; <a href="https://github.com/microbusiness" target="_blank" rel="noopener noreferrer">{tc('github')}</a>
        </p>
        <hr />

        <p>{t('intro')}</p>

        <h3>{t('methodsTitle')}</h3>

        <h4>{t('pmbok.title')}</h4>
        <p>{t('pmbok.text')}</p>

        <h4>{t('scram.title')}</h4>
        <p>{t('scram.text')}</p>

        <h4>{t('kanban.title')}</h4>
        <p>{t('kanban.text')}</p>

        <h4>{t('remoteKanban.title')}</h4>
        <p>{t('remoteKanban.text')}</p>

        <hr />
        <h3>{t('toolsTitle')}</h3>

        <h4>{t('git.title')}</h4>
        <p>{t('git.text')}</p>

        <h4>{t('tracking.title')}</h4>
        <p>{t('tracking.text')}</p>

        <h4>{t('incidents.title')}</h4>
        <p>{t('incidents.text')}</p>

        <h4>{t('deployment.title')}</h4>
        <p>{t('deployment.text')}</p>

        <hr />
        <p><em>{t('footer')}</em></p>

        <div className="d-flex flex-wrap mt-3" style={{ gap: '8px' }}>
          {tags.map(tag => (
            <span key={tag} className="badge badge-secondary" style={{ fontSize: '0.9rem', padding: '6px 10px' }}>{tag}</span>
          ))}
        </div>
      </div>
    </Layout>
  );
}
